import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchEnrollStudentsTableColumnNames, fetchAllEnrollStudents, createEnrollStudents, updateEnrollStudents, 
    deleteEnrollStudents, updateUserPreference, fetchAllCourses, fetchCountry, fetchGenders, fetchRoles, deleteUser, updateEnrollStudentsCoursePayment, 
    fetchAllRoles,
    fetchAllUserTypes} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable, { BasicTable } from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddForm from "../../../Components/Common/UserForm/AddEnrollUserForm";
import AddPaymentForm from "../../../Components/Common/AddPaymentForm/AddPaymentForm";
import { columns } from "./DataTableColumns";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import AddEnrollUserForm from "../../../Components/Common/UserForm/AddEnrollUserForm";


const labels = [
  {
    id: 1,
    labelName: "Search by (Name , Email, Mobile)",
    fieldName: "search-box",
    name: "UserId",
    value: "SearchBy",
    required: true,
  },
  {
    id: 1,
    labelName: "FirstName",
    fieldName: "text-box",
    name: "FirstName",
    value: "FirstName",
    required: true,
    errorMessage: "First Name is required",
  },
  {
    id: 2,
    labelName: "LastName",
    fieldName: "text-box",
    name: "LastName",
    value: "LastName",
    required: true,
    errorMessage: "Last Name is required",
  },
  {
    id: 3,
    labelName: "Email",
    fieldName: "email-box",
    type: "email",
    name: "Email",
    value: "Email",
    required: true,
    errorMessage: "Email is required",
  },
  {
    id: 5,
    labelName: "Mobile",
    fieldName: "mobile-box",
    type: "tel",
    name: "Mobile",
    value: "Mobile",
    required: true,
    errorMessage: "Mobile no. is required",
  },
  {
    id: 6,
    labelName: "Gender",
    fieldName: "gender-dropdown",
    type: "select",
    name: "GenderID",
    value: "GenderID",
    required: true,
    errorMessage: "Gender is required",
  },
  {
    id: 7,
    labelName: "User Type",
    fieldName: "user-type",
    type: "select",
    name: "UserTypeID",
    value: "UserTypeID",
    required: true,
    errorMessage: "User TypeId is required",
  },
  {
    id: 8,
    labelName: "Course",
    fieldName: "course-dropdown",
    name: "CourseID",
    value: "CourseID",
    required: true,
    errorMessage: "Course is required",
  }
];

const actionConfig = {
  cancel: {
    icon: "bx bxs-x-circle",
    tooltip: "cancel",
    isVisible: (item) => item.CourseID != null,
  },
  // edit: {
  //   icon: "ri-edit-2-line",
  //   tooltip: "Edit",
  //   isVisible: (item) => item.SessionStatusID != 4,
  // },
  // delete: {
  //   icon: "ri-delete-bin-2-line",
  //   tooltip: "Delete",
  //   isVisible: (item) => item.SessionStatusID != 4,
  // },
};


function EnrollStudents () {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  // const [showPayment, setShowPayment] = useState(false); // Not used in current logic flow for cancel
  const [showUnenrollConfirmModal, setShowUnenrollConfirmModal] = useState(false);
  const [studentToUnenroll, setStudentToUnenroll] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { Course, EnrollStudents, tableColumnNames, loading, module, Headerload } = useSelector((state) => ({
    EnrollStudents: state.EnrollStudents.enrollStudents,
    tableColumnNames: state.EnrollStudents.tableColumnNames,
    loading: state.EnrollStudents.loading,
    Headerload: state.EnrollStudents.headerload,
    module: state.Module.module,
}));

   // Compute permission
  const permission = (() => {
    // moduleId: 8 (Manage course), pageId: 15 (Enroll Student)
    return usePermissions(8, 15);
  })();

  // Rename RoleId to ID
  const updatedEnrollStudents = EnrollStudents?.map(({ UserId, ...rest }) => ({
    ID: UserId,
    ...rest,
  }));

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({ CountryCodeID: 61 });
  };

  const onEditClickHandler = (enrollStudents, value) => {
    setSelectedRow(enrollStudents);
    setIsAddOrEdit(value);
    // setRemoveCourse(true); // This seems to be for a different flow or an old implementation
  };

  
  const onSubmitHandler = (values, { resetForm }) => {
    
    let IsSystemUser = false;    

    const enrollStudentsObj = {
      FirstName: values.FirstName,
      LastName: values.LastName,
      CountryCodeID: parseInt(values.CountryCodeID),
      Mobile: values.Mobile,
      Email: values.Email,
      GenderID: parseInt(values.GenderID),
      RoleId: 3,
      IsSystemUser,
      CourseID: values.CourseID,
      UserTypeID: values.UserTypeID
    };

    if (isAddOrEdit === "isEdit") {
        enrollStudentsObj.ID = values?.ID;
        enrollStudentsObj.UserID = values.UserId; 
    } else if (isAddOrEdit === "isAdd") {
        if (values.UserId && values.UserId !== "NewStudent") {
            enrollStudentsObj.UserID = values.UserId;
        }
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createEnrollStudents(enrollStudentsObj)) :
      dispatch(updateEnrollStudents(enrollStudentsObj));

    resetForm();
    setShow(false);
  };

  const onSubmitPaymentHandler = (item, title, inputValue) => {
    
     const enrollStudentsObj = {
      PaymentID: item.PaymentID, 
      [title]: inputValue
    }
    dispatch(updateEnrollStudentsCoursePayment(enrollStudentsObj))

  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchEnrollStudentsTableColumnNames({
          module: "ENROLLSTUDENTS"
        })
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteUser({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const initiateUnenrollStudent = (item) => {
    setStudentToUnenroll(item);
    setShowUnenrollConfirmModal(true);
  };

  const confirmUnenrollStudent = () => {
    if (!studentToUnenroll) return;
    dispatch(updateEnrollStudents({ CourseID: studentToUnenroll.CourseID, UserID: studentToUnenroll.UserIDs[0] })) 
      .then(() => {
        // Optionally reset selection or show success message
      })
      .catch((error) => {
        console.error("Error unenrolling student:", error);
      });
    setShowUnenrollConfirmModal(false);
    setStudentToUnenroll(null);
  };
  
  useEffect(() => {
    dispatch(fetchEnrollStudentsTableColumnNames({ module: "ENROLLSTUDENTS" }))
    dispatch(fetchAllEnrollStudents());
    dispatch(fetchAllCourses());
    dispatch(fetchAllUserTypes({IsActive: true}));
    dispatch(fetchCountry());
    dispatch(fetchGenders());
    dispatch(fetchAllRoles({IsActive: true , hasAccess: true}));    
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Enroll Students")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4 ">
                  <Col className="col-sm-auto">
                    <div>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                          disabled={loading}
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <>
                    <div className="listjs-table" id="customerList">
                       <CommonDataTable
                        data={updatedEnrollStudents}
                        tableColumnNames={tableColumnNames}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onInlineUpdate={onSubmitPaymentHandler}
                        handleCancel={initiateUnenrollStudent} 
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        actionConfig={actionConfig}
                        permission={permission}
                      />
                    </div>
                  </>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Modal  */}
      <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow}
        FormBody={AddEnrollUserForm}
        title={isAddOrEdit === "isAdd" ? t("Add New Enroll Students") : t("Edit Enroll Students")}
        size="xl"
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={t("Are you sure you want to delete this record?")}
      />

      {/* Unenroll Student Confirmation Modal */}
      <DeleteModal
        showDelete={showUnenrollConfirmModal}
        setShowDelete={setShowUnenrollConfirmModal}
        onDeleteClick={confirmUnenrollStudent}
        setSelectedIds={setSelectedIds} // Pass the function here
        confirmBtnText={`Yes Cancel It!`}
        description={t("Are you sure you want to unenroll this student from the course?")}
      />
    </div>
  );
}

export default EnrollStudents;